// extracted by mini-css-extract-plugin
export default {"field":"CategoryEditDialog_field__FwoYF","rationale":"CategoryEditDialog_rationale__jJZo8"};